<div id="holdings" style="overflow: hidden">
  <h5 class="rps-heading-five">Holding
    details</h5>
  <ng-template [ngIf]="mainDataSet" #tabset>
    <p class="date rps-paragraph-two rps-grey"
       *ngIf="mainDataSet?.asOfDate && (!profileData.isMoneyMarket || profileData.isMoneyMarket && legalAccepted)"
       data-rpa-tag-id="holdingDetailDate">as
      of {{ mainDataSet?.asOfDate | ESTPipe }}
    </p>
    <div class="tabset-container"
         *ngIf="(profileData?.isMoneyMarket && legalAccepted || !profileData?.isMoneyMarket) && profileData?.fundId!=='0517'">
      <div #holdingDetailsTabs>
        <c11n-tabs [activeItem]="activeTab"
                   (activeItemChange)="$event === 'pcf-holdings' ? getPcfHoldings() : setData($event)"
                   smallResponsiveBreakpoint="375" variant="left-aligned" overflowOption="nav-overflow"
                   id="holding-details-tabset">
          <c11n-tab-panel id="equity" labelText="Equity" *ngIf="(!profileData?.isEtfOfEtfs)">
            <div class="c11n-text-crop">
              <ng-container *ngIf="false else c11nTabHoldingDetailsContent"> </ng-container>
            </div>
          </c11n-tab-panel>
          <c11n-tab-panel id="bond" labelText="Fixed income" *ngIf="(!profileData?.isEtfOfEtfs)">
            <div class="c11n-text-crop">
              <ng-container *ngIf="false else c11nTabHoldingDetailsContent"> </ng-container>
            </div>
          </c11n-tab-panel>
          <c11n-tab-panel id="short-term reserve" labelText="Short-term reserve" *ngIf="(!profileData?.isEtfOfEtfs)">
            <div class="c11n-text-crop">
              <ng-container *ngIf="false else c11nTabHoldingDetailsContent"> </ng-container>
            </div>
          </c11n-tab-panel>
          <c11n-tab-panel id="derivative" labelText="Derivatives" *ngIf="viewDaily">
            <div class="c11n-text-crop">
              <ng-container *ngIf="false else c11nTabHoldingDetailsContent"> </ng-container>
            </div>
          </c11n-tab-panel>
          <c11n-tab-panel id="commodity" labelText="Commodities" *ngIf="(profileData?.fundId==1298)">
            <div class="c11n-text-crop">
              <ng-container *ngIf="false else c11nTabHoldingDetailsContent"> </ng-container>
            </div>
          </c11n-tab-panel>
          <c11n-tab-panel id="currency" labelText="Currencies" *ngIf="(profileData?.fundId==='1298')">
            <div class="c11n-text-crop">
              <ng-container *ngIf="false else c11nTabHoldingDetailsContent"> </ng-container>
            </div>
          </c11n-tab-panel>
          <c11n-tab-panel id="pcf-holdings" labelText="Portfolio composition file" *ngIf="(profileData?.isETF)">
            <div class="c11n-text-crop">
              <ng-container *ngIf="false else c11nTabHoldingDetailsContent"> </ng-container>
            </div>
          </c11n-tab-panel>
          <ng-template #c11nTabHoldingDetailsContent>
            <div id="holding-details-tabpanel">
              <div *ngIf="(currentType==='pcf-holdings' && pcfHoldingFormatted?.size>0 && pcfAcceptedFlag)">
                <p class='pcf-info' [innerHTML]="institutionalInvestorDisclaimer?.contentValue"></p>
                <h5 class="rps-heading-five">Portfolio composition file</h5>
                <p class='date rps-paragraph-two rps-grey'>as of {{ pcfHoldingFormatted?.asOfDate | ESTPipe }}</p>
              </div>
              <div class="money-market-extra-container"
                   *ngIf="profileData?.isMoneyMarket && (currentType==='short-term reserve' || currentType==='money-market-range') && mainDataSet.size>0">
                <div class="flex-row">
                  <p class="tab-active date-range rps-paragraph-one">View</p>
                  <date-range-select [dateRanges]='holdingsDateRange' (dateRangedData)="fetchDateRangeResults($event)">
                  </date-range-select>
                </div>
                <div>
                  <money-market-characteristic-results [weightedAverageLife]='mainDataSet?.weightedAverageLife'
                                                       [weightedAverageMaturity]='mainDataSet?.weightedAverageMaturity'></money-market-characteristic-results>
                </div>
              </div>
              <pcf-container *ngIf="currentType==='pcf-holdings' && !pcfAcceptedFlag"
                             (pcfActionEmitter)="setPcfFlag($event)" [fundId]='profileData?.fundId' [asOfDate]='pcfAsOfDate'>
              </pcf-container>
              <holding-details-results *ngIf="currentType!==''"
                                       ngClass="{'hide-class': (currentType==='pcf-holdings' && !pcfAcceptedFlag)}"
                                       [holdingsData]='mainDataSet' [currentType]='currentType' [profileData]='profileData'
                                       [pcfAcceptedFlag]='pcfAcceptedFlag' results>
              </holding-details-results>
            </div>
          </ng-template>
        </c11n-tabs>
      </div>
    </div>
    <div class="row" style="margin-top: 25px">
      <div [ngClass]="{'col-md-7':isTabletDevice, 'col-md-12':!isTabletDevice}">
        <div class="holding-details-pagination-container pt-2"
             [ngClass]="{'col-md-5':isTabletDevice, 'col-md-3':!isTabletDevice}">
          <holding-details-pagination
            *ngIf="mainDataSet.size > 0 && (((profileData?.isMoneyMarket && legalAccepted) || (!profileData?.isMoneyMarket && currentType!=='pcf-holdings') || (currentType=='pcf-holdings' && pcfAcceptedFlag)))"
            [listSize]="mainDataSet.size" (newPageNumber)="setPageNumber($event)"
            (extraHoldings)="modifyHoldings($event)" [fundId]='profileData?.fundId' [currentType]='currentType'
            [viewDaily]='viewDaily' [isMoneyMarket]='profileData?.isMoneyMarket'>
          </holding-details-pagination>
          <div>
          </div>
        </div>
        <div id="links">
          <p class="deviations-footnote rps-paragraph-one rps-grey"
             *ngIf="profileData?.isStandaloneEtf && currentType!=='pcf-holdings'">*There may
            be deviations when applying
            fair value and other considerations.</p>
          <div>
            <a class="link solid-line padding-bottom-10px" *ngIf="profileData?.fundId==0517"
               [href]="advisorsStategyFund" target="_blank">Portfolio holdings</a>
            <a class="link vg-disclaimer flex-column row-space" tabindex="0" role="button"
               *ngIf="(currentType!=='pcf-holdings' && !profileData?.isMoneyMarket) || (currentType==='pcf-holdings' && pcfAcceptedFlag) || (profileData?.isMoneyMarket && legalAccepted)"
               (click)="holdingsModalDialog.openModalDialog();" href="javascript:void(0)">Vanguard
              portfolio holdings disclaimer</a>
            <a *ngIf='profileData?.fundId==0517' class="link solid-line" [href]="swapFileUrl" target="_blank">View the
              most recent custom swap holding details <c11n-icon class="d-inline-block" [name]="'document-pdf'"
                                                                 [size]="'medium'" [altText]="'PDF file'"></c11n-icon></a><br>
          </div>
        </div>
        <div class="flex-column">
          <p *ngIf='profileData?.isMoneyMarket && !legalAccepted' class='cusip-legal rps-paragraph-one rps-grey'>The
            Fund's holdings contain CUSIP
            numbers, which are subject to certain terms and conditions. In order to access the holdings <a class="link"
                                                                                                           role="button" tabindex="0" (click)="legalTermsDialog.openModalDialog();" href="javascript:void(0)">read
              and accept</a>
            these terms and conditions.</p>
          <p *ngIf='profileData?.isMoneyMarket' class="rps-paragraph-one rps-mark-bold">Visit <a class="link solid-line"
                                                                                                 [href]="secLink" target="_blank">sec.gov <c11n-icon class="d-inline-block" [name]="'pop-window'"
                                                                                                                                                     [size]="'small'" [altText]="'opens a new window'"></c11n-icon></a> to obtain the most
            recent 12 months of publicly available information filed by the fund with the SEC on Form N-MFP</p>
        </div>
      </div>
    </div>

  </ng-template>

  <c11n-modal-dialog modalId="legalTermsModal" [headingText]="'Visitor legal terms'" #legalTermsDialog>
    <div c11n-modal-dialog-body>
      <visitor-legal-terms
        (userAction)='userLegalAction($event); legalTermsDialog.closeDialogModal($event)'></visitor-legal-terms>
    </div>
  </c11n-modal-dialog>

  <c11n-modal-dialog modalId="holdingsDisclaimerModal" [headingText]="'Vanguard portfolio holdings disclaimer'"
                     #holdingsModalDialog>
    <div c11n-modal-dialog-body>
      <div>
        <p [innerHTML]="holdingsDetailsDisclaimer?.contentValue"></p>
      </div>
    </div>
  </c11n-modal-dialog>

  <ng-template [ngIf]="!mainDataSet" #noData>
    <p class='no-data'>This information is temporarily unavailable.</p>
  </ng-template>
</div>
